<script>
import CarouselComponent from "@/views/components/CarouselComponent.vue";
import DepService from "@/api/services/depService";
import {mapMutations, mapState} from "vuex";

export default {
  data() {
    return {
      unsubscribeMessage: null,
      unsubscribeError: false
    };
  },
  name: "UpgradePackageConfirmationView",
  components: {
    CarouselComponent
  },
  computed: {
    ...mapState(['user', 'productId','currentSeason'])
  },
  methods: {
    ...mapMutations(['setUser']),
    changePayment() {
      this.$router.push("/upgrade-package");
    },
    goBack() {
      this.$router.push(`/profile`);
    },

    async getUser() {
      const updatedUser = await DepService.getUserViaProductId(this.user.msisdn, this.productId)

      this.setUser(updatedUser.data.user)
    },

    async unsubscribe() {
      try {
        const { msisdn } = this.user;
        const productId = this.productId;

        console.log('Msisdn:', msisdn);
        console.log('ProductId:', productId);

        if (!msisdn || !productId) {
          this.unsubscribeMessage = "Missing user information.";
          this.unsubscribeError = true;

          return;
        }

        const response = await DepService.unSubscribeUser(msisdn, productId);

        if (response.data.result === true) {
          this.unsubscribeMessage = "You have been unsubscribed successfully!";
          this.unsubscribeError = false;
          setTimeout(() => {
            this.$router.push('/');
          }, 1500);
        } else {
          this.unsubscribeMessage = response.data.reason || "Could not unsubscribe.";
          this.unsubscribeError = true;
        }

      } catch (error) {
        console.error("Error response:", error.response?.data);
        this.unsubscribeMessage = error.response?.data?.reason || "Could not unsubscribe.";
        this.unsubscribeError = true;
      }
    }
  }

}

</script>

<template>
  <div class="d-flex flex-column justify-content-center align-items-center col-12 mt-4">

  <div class="col-12 px-3 mt-2">
    <img :src="isFreeUser ? require('@/assets/logos/logo-free.png') : require('@/assets/logos/logo-vip.png')"  class="logo col-5" alt="logo" />
  </div>

    <div class="d-flex flex-column justify-content-center align-items-center col-12 mb-4 mt-4">
      <CarouselComponent :season="currentSeason" />
    </div>

    <div class="d-flex justify-content-center align-items-center flex-column">

      <div class="heading">Manage your Mzansi</div>
      <div class="heading">Rhythm Subscription</div>

      <div class = "mt-2 normalText">You are currently on the <span>VIP Mode</span> of</div>
      <div class="normalText">Mzansi Rhythm, for R5/Day.</div>

    </div>

    <div class="col-11 mt-5">
      <div class="d-flex justify-content-center align-items-center p-3 yellowText buttonText" @click = changePayment>Change Payment Plan</div>
    </div>

    <div class="col-11 mt-3">
      <div class="d-flex justify-content-center align-items-center p-3 buttonText blackbut" @click = goBack>Go Back</div>
    </div>

    <div class="col-12 p-3 mt-4">
      <div class="d-flex justify-content-center align-items-center buttonText unsub" @click="unsubscribe">Unsubscribe</div>
    </div>
    <p
        v-if="unsubscribeMessage"
        :class="unsubscribeError ? 'error-text' : 'success-text'"
        class="mt-2 text-center"
    >
      {{ unsubscribeMessage }}
    </p>

  </div>

</template>

<style scoped>

.heading{
  font-weight: 600;
  font-size: 19px;
  color: #000F56;
}

.normalText{
  font-weight: 400;
  font-size: 14px;
  color: #000F56;
}

.yellowText{
  border-radius: 30px;
  background: #FFCB05;
}

.buttonText{
  font-weight: 600;
  font-size: 19px;
  color: #000000;
}

.blackbut{
  border-radius: 30px;
  background: #000000;
  color: #fff;
}

.unsub{
  text-decoration: underline;
}

.error-text {
  color: red;
  font-size: 14px;
}

.success-text {
  color: green;
  font-size: 14px;
}

</style>